const getWasteEntry = state => state.wasteEntry;

export default getWasteEntry;
